var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiabilityRiskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0692 6.74513L16.0923 0.142072C15.6921 -0.0476538 15.2273 -0.0470609 14.8265 0.142072L0.849024 6.74513C0.330242 6.99 0 7.51174 0 8.08507V21.4353C0 24.5391 1.37136 27.411 3.66764 29.1186L14.5751 37.2288C14.8378 37.4238 15.1484 37.5217 15.4597 37.5217C15.771 37.5217 16.0817 37.4238 16.3437 37.2288L27.2512 29.1186C29.5475 27.4116 30.9188 24.5391 30.9188 21.4353V8.08507C30.9182 7.51174 30.588 6.99 30.0692 6.74513ZM27.9538 21.4353C27.9538 23.6064 27.0294 25.5897 25.4826 26.7399L15.4591 34.1926L5.43565 26.7399C3.8882 25.5891 2.96388 23.6058 2.96388 21.4353V9.02422L15.4591 3.12136L27.9538 9.02422V21.4353Z",
    fill: "#3C4652"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4592 5.41602L5.03906 10.3382V21.4348C5.03906 22.9526 5.65034 24.3127 6.67426 25.0746L15.4592 31.6059L24.2453 25.0746C25.2686 24.3139 25.8793 22.9532 25.8793 21.4348V10.3382L15.4592 5.41602ZM12.2658 12.0879C12.3168 11.6396 12.4277 11.1908 12.7621 10.7426C14.1341 8.90164 16.7843 8.92061 18.1604 10.7426C18.4948 11.1914 18.6063 11.6396 18.6567 12.0884C18.793 13.5304 18.0234 15.1448 16.996 16.1249C16.1019 16.9774 14.7934 16.9537 13.9259 16.1249C12.9115 15.1543 12.104 13.5209 12.2658 12.0879ZM20.6144 23.5206C20.6144 24.4936 19.8258 25.2821 18.8529 25.2821H12.0654C11.0925 25.2821 10.304 24.4936 10.304 23.5206V21.8089C10.304 20.6338 10.8352 19.4842 11.8176 18.8391C12.3797 18.4704 13.0497 18.2587 13.7599 18.2587H17.1584C17.8693 18.2587 18.5387 18.4704 19.1007 18.8391C20.0832 19.4842 20.6144 20.6338 20.6144 21.8089V23.5206Z",
    fill: "#2D7ABE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiabilityRiskIcon);
export default __webpack_public_path__ + "static/media/liabilityRiskIcon.13ea57e7.svg";
export { ForwardRef as ReactComponent };